import {
  REQUEST_PATENTS_MAIN_SEARCH,
  RESPONSE_PATENTS_MAIN_SEARCH,
  FAILURE_PATENTS_MAIN_SEARCH,
} from "../../actions/types";

const initialState = {
  isFetching: false,
  isInitialScreen: true,
  results: [],
  error: false,
  filters: {
    Filed: true,
    Granted: true,
    Published: true,
    size: 25,
    from: 0,
    activePage: 1,
    keyword: '',
    sort: {
      name: "publication_date",
      order: "desc"
    }
  },
};

const setRequest = (state, action) => {
  const filters = action.payload?.filters || {};
  return {
    ...state,
    filters,
    isInitialScreen: false,
    isFetching: true,
  };
};

const setResponse = (state, action) => {
  let { results = [], total = 0, totalArticles,
    totalPatents,
    totalConflicts,
    totalExperts } = action.payload;
  results = results || [];
  total = total || 0;

  return {
    ...state,
    isFetching: false,
    error: false,
    results,
    total,
    totalArticles,
    totalPatents,
    totalExperts,
    totalConflicts
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    results: [],
    total: 0,
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_PATENTS_MAIN_SEARCH:
      return setRequest(state, action);

    case RESPONSE_PATENTS_MAIN_SEARCH:
      return setResponse(state, action);

    case FAILURE_PATENTS_MAIN_SEARCH:
      return setFailure(state, action);

    default:
      return state;
      break;
  }
};
